import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import Select from "react-select";
import swal from "sweetalert";
import useSWR from "swr";
import NotFoundPage from "../../../StoreComponents/NotFoundPage";
import { API } from "../../../StoreComponents/conflict";
import { PostStoreLog } from "../../../StoreComponents/hooks/useStoreLog";
import "./ProductList.css";

const fetcher = (url) =>
  API.get(url, {
    headers: {
      search: `%%`,
    },
  }).then((res) => res.data.data);

const ProductList = () => {
  const [pageIndex, setPageIndex] = useState(0);
  const [limit, setLimit] = useState(50);
  const { data: categoryOption, error } = useSWR(
    `store/settings/categories?page=${0}&limit=${10000}`,
    fetcher
  );
  const {
    data: categoryBox,
    error: error2,
    mutate: mutate1,
  } = useSWR(`store/settings/categories-data`, fetcher);
  const {
    data: productData,
    error: error1,
    mutate,
  } = useSWR(
    `store/settings/products?page=${pageIndex}&limit=${limit}`,
    fetcher
  );
  console.log(categoryBox);
  const [openElement, setOpenElement] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [search, setSearch] = useState("");

  // set category select list
  let category = [];
  if (categoryOption && categoryOption.length > 0) {
    category = categoryOption.map((data) => {
      let optionsItem = {};
      optionsItem.value = data.cat_id;
      optionsItem.label = `${data.categoryen} (${data.categorybn})`;
      return optionsItem;
    });
  }

  const handleToggle = () => {
    if (!openElement) {
      setOpenElement(true);
    } else {
      setOpenElement(false);
    }
  };

  const handleCategory = (name) => {
    setSelectedCategory(name.value);
  };

  // react hook form
  const { register, handleSubmit, reset } = useForm();
  const {
    register: register1,
    reset: reset1,
    formState: { errors: errors1 },
    handleSubmit: handleSubmit1,
  } = useForm();
  const [buttonLoading, setButtonLoading] = useState(false);
  // POST PRODUCT
  const onSubmit = (data) => {
    data.procate = parseInt(selectedCategory);
    setButtonLoading(true);
    API.post("store/settings/products", data).then((res) => {
      if (!res.data.error) {
        swal({
          title: "Thank You !",
          text: "Successfully Added",
          icon: "success",
          button: "Ok",
        });
        reset();
        PostStoreLog(1, "new product list name Added");
        setButtonLoading(false);
        mutate();
        mutate1();
      }
    });
  };

  // Update Section
  const [getId, setGetId] = useState(null);
  // get product Data By ID
  const { data: productById, mutate: mutate2 } = useSWR(
    getId ? `store/settings/product/${getId}` : null,
    fetcher
  );

  //   Update supliers
  const onSubmitUpdate = (data) => {
    if (selectedCategory) {
      data.procate = parseInt(selectedCategory);
    } else {
      data.procate = productById.PROCATE;
    }
    if (!data.proname) {
      data.proname = productById.PRONAME;
    }
    if (!data.pronametwo) {
      data.pronametwo = productById.PRONAMETWO;
    }

    API.put("store/settings/products", data, {
      headers: {
        prodid: getId,
      },
    }).then((res) => {
      if (!res.data.error) {
        swal({
          title: "Thank You !",
          text: "Successfully Added",
          icon: "success",
          button: "Ok",
        });
        PostStoreLog(2, "product list name update");
        window.$("#edit_product_list").modal("hide");
        reset1();
        window.location.reload();
        mutate();
        mutate2();
        mutate1();
      }
    });
  };
  // Get product Id
  const handleUpdate = (updateId) => {
    reset1();
    setGetId(updateId);
  };

  //  DELETE Suplier

  const deleteButtonHandler = (Id) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        API.delete("store/settings/products", {
          headers: {
            prodid: Id,
          },
        }).then((res) => {
          if (res) {
            PostStoreLog(3, " Product list Name delete");
            mutate();
            mutate1();
          }
        });
        swal("Poof! Your imaginary file has been deleted!", {
          icon: "success",
        });
      } else {
        swal("Your imaginary file is safe!");
      }
    });
  };

  // Search Implement
  const handleSearch = async (e) => {
    e.preventDefault();
    const search = e.target.value;
    setSearch(search);
    let limit = search === "" ? 10 : 1000;
    const res = await API.get(
      `store/settings/products?page=${0}&limit=${limit}`,
      {
        headers: {
          search: `%${search}%`,
        },
      }
    )
      .then((res) => res.data.data)
      .catch((error) => {
        if (error.name === "TypeError") {
          console.log("Data not found for the quary");
        }
      });
    if (res) {
      mutate(res, false);
    } else {
      mutate({ rows: [], totalCount: { TOTAL_PRODUCTS: null } }, false);
    }
  };

  //   let counter = 1;
  return (
    <>
      <Helmet>
        <title>Product List - BBA STORE</title>
        <meta name="description" content="Product List - BBA STORE" />
      </Helmet>
      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important}"
        }
      </style>
      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          {productData ? (
            <div className="d-flex align-items-center justify-content-between mb-4 search-div_store">
              <h3 className="text-start text-dark">
                Manage All Products (Total Product :{" "}
                {productData.totalCount
                  ? productData.totalCount.total_products
                  : ""}
                )
              </h3>
              <button
                onClick={handleToggle}
                type="button"
                className="btn  px-3 btn-color_store"
              >
                <i className="fa fa-plus"></i>
                <span> Add Product</span>
              </button>
            </div>
          ) : (
            ""
          )}

          {/* Toogle Element */}
          <div className={openElement ? "category show" : "category"}>
            <div className="mx-auto">
              <div className="add_category">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="row mx-3">
                    <div className="col-12 col-md-4 col-lg-4 data-table_store">
                      <Select
                        onChange={handleCategory}
                        style={{ borderRadius: "10px" }}
                        className="text-start fs-6"
                        options={category}
                      />
                      <input
                        tabIndex={-1}
                        autoComplete="off"
                        style={{ opacity: 0, height: 0 }}
                        value={selectedCategory}
                        required
                      />
                    </div>
                    <div className="col-12 col-md-4 col-lg-4 data-table_store">
                      <input
                        {...register("proname")}
                        placeholder="Bangla Name"
                        type="text"
                        className="p-2 input-field_store"
                      />
                    </div>
                    <div className="col-12 col-md-4 col-lg-4 data-table_store">
                      <input
                        {...register("pronametwo")}
                        placeholder="English Name"
                        type="text"
                        className="p-2 input-field_store"
                      />
                    </div>
                  </div>
                  <br />
                  <div className=" text-center">
                    <button
                      type="submit"
                      className="mt-3 px-5 btn btn-color_store text-center"
                    >
                      <i className="fa fa-save"></i>
                      <span> Submit</span>
                      {buttonLoading ? (
                        <div
                          style={{ width: "20px", height: "20px" }}
                          class="spinner-border ms-2  text-light"
                          role="status"
                        >
                          <span style={{}} class="visually-hidden ">
                            Loading...
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {/* Toogle Element */}
          {/* style={{background: 'white', borderRadius: '10px'}} */}
          {/* Product By Category */}
          <div className="my-4 ">
            <div className="row m-0">
              {categoryBox
                ? categoryBox.map((item) => (
                  <div className="col-12 col-md-6 my-2 col-lg-6 ">
                    <Link to={`/settings/productList/${item.cat_id}`}>
                      <div
                        className="d-flex  align-items-center"
                        style={{
                          boxShadow:
                            "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                          borderRadius: "5px",
                        }}
                      >
                        <div className="px-5 py-4 tableColor  rounded-start  ">
                          <i className="fa fa-gift text-white fs-1 mt-2"></i>
                        </div>
                        <div className="ms-3 lh-1">
                          <h5
                            className="lh-1  pt-1 fs-6"
                            style={{
                              fontFamily:
                                "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                              fontWeight: "600",
                            }}
                          >
                            {item.categorybn
                              ? item.categorybn.toUpperCase()
                              : ""}
                          </h5>
                          <h5 className="lh-1 fw-normal">
                            {item.categoryen ? item.categoryen : ""}
                          </h5>
                          <p
                            className="text-start fs-5 "
                            style={{ fontWeight: "600" }}
                          >
                            <a href="#">{item.products}</a>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))
                : ""}
            </div>
          </div>
          {!productData ? (
            <NotFoundPage />
          ) : (
            <div
              className="my-4 table-container p-2"
              style={{ background: "white", borderRadius: "10px" }}
            >
              <div className="d-flex justify-content-between align-items-center search-div_store">
                <div className="col-12 col-md-6 col-lg-4">
                  <p className="text-start mt-4 fs-6 text-black-50">
                    Show Entries :
                    <select
                      onClick={(e) => {
                        setLimit(parseInt(e.target.value));
                      }}
                      className="ms-2 btn-outline-color "
                    >
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                    {/* <span  className="fw-bold ms-3 text-primary showEntry">{productData?productData.rows.length:""}</span> */}
                  </p>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <input
                    className="p-2 input-field_store w-100"
                    type="text"
                    name="Search"
                    onChange={(e) => handleSearch(e)}
                    placeholder="Search Products"
                  />
                </div>
              </div>
              <div className="table-responsive data-table_store">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr className="tableColor">
                      <th colSpan="1">S/N</th>
                      <th colSpan="1">Bangla Name</th>
                      <th colSpan="1">English Name</th>
                      <th colSpan="1">Category</th>
                      <th colSpan="1">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {productData.rows.map((item, index) => (
                      <tr key={index}>
                        <th>{++index}</th>
                        <td>{item.PRONAME}</td>
                        <td>{item.PRONAMETWO}</td>
                        <td>{item.CATEGORYEN}</td>
                        <td>
                          <button
                            data-bs-toggle="tooltip"
                            title="Edit"
                            data-toggle="modal"
                            data-target="#edit_product_list"
                            onClick={() => {
                              handleUpdate(item.PRODID);
                            }}
                            type="button"
                            className="btn btn-outline-color px-3 me-2"
                          >
                            <i className="fa fa-edit"></i>
                          </button>
                          <button
                            data-bs-toggle="tooltip"
                            title="Delete"
                            onClick={() => {
                              deleteButtonHandler(item.PRODID);
                            }}
                            type="button"
                            className="btn btn-danger px-3"
                          >
                            <i className="fa fa-trash-o"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {search.length > 0 ? (
                <div></div>
              ) : (
                <div className="text-end mt-4 mb-3">
                  {pageIndex > 0 && (
                    <button
                      type="button"
                      className="btn btn-outline-color_store px-4 me-2"
                      onClick={() => setPageIndex(pageIndex - 1)}
                    >
                      Previous
                    </button>
                  )}

                  {productData && productData.rows.length === limit ? (
                    <button
                      type="button"
                      className="btn btn-outline-color_store px-4 me-2"
                      onClick={() => setPageIndex(pageIndex + 1)}
                    >
                      Next
                    </button>
                  ) : (
                    ""
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      {/* Edit product list Modal */}
      <div
        id="edit_product_list"
        className="modal custom-modal fade"
        role="dialog"
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Product</h5>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
              >
              </button>
            </div>
            {productById !== undefined && (
              <div className="modal-body text-start">
                <form onSubmit={handleSubmit1(onSubmitUpdate)}>
                  <div className="container px-4">
                    <div className="row mx-3">
                      <div className="col-sm-12 col-md-12 col-lg-12  data-table_store">
                        <Select
                          onChange={handleCategory}
                          style={{ borderRadius: "10px" }}
                          placeholder={
                            productById
                              ? `${productById.CATEGORYEN} (${productById.CATEGORYBN})`
                              : ""
                          }
                          className="text-start fs-6"
                          options={category}
                        />
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-6 data-table my-3">
                        <input
                          {...register1("pronametwo")}
                          defaultValue={
                            productById ? productById.PRONAMETWO : ""
                          }
                          type="text"
                          className="p-2 input-field_store"
                        />
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-6 data-table_store my-3">
                        <input
                          {...register1("proname")}
                          defaultValue={productById ? productById.PRONAME : ""}
                          type="text"
                          className="p-2 input-field_store"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="submit-section">
                    <button
                      type="submit"
                      className="btn btn-color_store px-5 py-2 rounded"
                    >
                      Update
                    </button>

                    <button
                      type="button"
                      className="btn btn-color_store px-5 ms-1 py-2 rounded"
                      data-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </form>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductList;
